<template>
  <div class="camera">
    <img
      :src="stream"
      alt="Stream"
      data-video-stream
      class="camera__player"
    />
    <div
      v-if="$slots.overlay"
      class="camera__overlay"
    >
      <slot name="overlay" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Camera',
  data() {
    return {
      isStarted: false,
    };
  },
  staticData: () => ({
    stream: process.env.VUE_APP_VIDEO_STREAM,
    videoApi: process.env.VUE_APP_VIDEO_API,
  }),
  created() {
    this.initActions();
  },
  methods: {
    async start(hasBorders = false) {
      try {
        await this.$robot.faceRecognizeService.enableBorders(hasBorders);
        await this.$robot.cameraService.startCamera();
      } catch (e) {
        this.sendError(e);
      }
    },
    stop() {
      if (!this.isStarted) return;
      this.$robot.cameraService.stopCamera();
      this.isStarted = false;
    },
    async takePhoto() {
      try {
        const mimeType = 'image/png';
        const fullPath = await this.$robot.cameraService.makePhoto();
        const filename = fullPath.split('/home/promobot/').pop();
        const base64 = await this.$robot.filesystemService.loadFile(mimeType, filename);
        if (filename && base64) {
          this.$emit('photo', {
            original: base64,
            base64,
            filename,
            fullPath,
            mimeType,
          });
        }
      } catch (e) {
        this.sendError(e);
      }
    },
    async startRecording() {
      try {
        this.$robot.dialogService.abortRobotReplic();
        this.$robot.dialogService.muteOn();
        await this.$axios.get(`${this.videoApi}/start`);
      } catch (e) {
        this.sendError(e);
        throw e;
      }
    },
    async stopRecording() {
      try {
        this.$robot.dialogService.muteOff();

        const { data } = await this.$axios.get(`${this.videoApi}/stop`);
        const fullPath = data.filename;
        const filename = fullPath?.split('/').pop();

        if (fullPath && filename) {
          this.$emit('video', { filename, fullPath });
        }
      } catch (e) {
        this.sendError(e);
        throw e;
      }
    },
    sendStart() {
      this.isStarted = true;
      return this.$emit('start');
    },
    sendError(e) {
      console.error(e);
      return this.$emit('error', e);
    },
    initActions() {
      const robotActions = [
        this.$robot.cameraService.onCameraStart(this.sendStart),
        this.$robot.cameraService.onCameraError(this.sendError),
      ];

      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
        this.stop();
      });
    },
  },
};
</script>

<style lang="stylus">
.camera
  position relative
  display block
  width 100%
  height 100%
  background-color #000

  &__player
    display block
    width 100%
    height 100%
    object-fit contain

  &__overlay
    abs top left right bottom
    background-color inherit
    z-index 3
    // & > .video
    //   width 100%
    //   height 100%

  &__image
    display block
    height 100%
    margin 0 auto
</style>
